module.exports = __webpack_public_path__ + "static/media/T13.dd79a6b4.jpg";